<template>
    <section class="py-20 px-4">
      <div class="max-w-3xl mx-auto text-center mb-12">
        <h2 class="text-3xl md:text-4xl font-bold mb-4">Perguntas Frequentes</h2>
      </div>
  
      <div class="max-w-3xl mx-auto divide-y divide-gray-200">
        <div
          v-for="(faq, index) in faqs"
          :key="index"
          class="py-4"
        >
          <button
            @click="toggle(index)"
            class="w-full flex justify-between items-center text-left focus:outline-none"
          >
            <span
              :class="[
                'text-base md:text-lg font-medium transition',
                activeIndex === index ? 'text-pink-500' : 'text-gray-900'
              ]"
            >
              {{ faq.pergunta }}
            </span>
            <span
            :class="[
                'text-xl font-bold transition-transform duration-200',
                'inline-block transform',
                activeIndex === index ? 'rotate-45 text-pink-500' : 'rotate-0 text-black'
            ]"
            >
            +
            </span>
          </button>
  
          <div
            v-if="activeIndex === index"
            class="mt-2 text-sm text-gray-500"
          >
            {{ faq.resposta }}
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  
  const activeIndex = ref(0)
  
  const toggle = (index) => {
    activeIndex.value = activeIndex.value === index ? null : index
  }
  
  const faqs = [
    {
      pergunta: 'Preciso de um domínio registrado?',
      resposta: 'Não, a Integrator fornece um subdomínio grátis para você acessar seu site e aplicativo.',
    },
    {
      pergunta: 'Tem suporte ao painel de controle?',
      resposta: 'Sim, via Ticket e ajuda via Wiki.',
    },
    {
      pergunta: 'Posso fazer upgrade ou downgrade?',
      resposta: 'Não, o upgrade ou downgrade não é permitido em VPS.',
    },
    {
      pergunta: 'Tenho período de teste antes de fazer o pagamento?',
      resposta: 'Não, devido a custos o acesso é liberado somente após a confirmação de pagamento.',
    },
    {
      pergunta: 'Tem fidelização na assinatura?',
      resposta: 'Não! Você pode cancelar quando quiser, sem taxas de fidelidade.',
    },
    {
      pergunta: 'Onde estão localizados o ambiente VPS?',
      resposta: 'Nossa infraestrutura se encontra espalhada pelo Canadá e EUA.',
    },
    {
      pergunta: 'Termos de pagamento',
      resposta: 'Aceitamos pagamentos mensais, semestral ou anual. Quanto maior o período, maior o desconto!',
    },
  ]
  </script>
  